export default __webpack_public_path__ + "static/media/975.2f561538.png";